'use client';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { WHAT_PEOPLE_SAY_QUERIES } from '../../infrastructure/whatPeopleSay/utils/queries';
import type { WhatPeopleSayQueryParams } from '../../model/whatPeopleSay/whatPeopleSay';

export const useWhatPeopleSayService = () => {
  const useSuspenseWhatPeopleSay = (params: WhatPeopleSayQueryParams) =>
    useSuspenseQuery(WHAT_PEOPLE_SAY_QUERIES.getWhatPeopleSay(params));

  /**
   * Non-suspense read, for call sites this request must not block.
   *
   * The PDP section tab bar needs the insight to decide the Reviews dot, but it renders above
   * the fold and pins to the viewport — suspending it would hold the entire bar until the
   * insight resolves. It reuses `WHAT_PEOPLE_SAY_QUERIES`, so it shares a cache entry with the
   * section's suspense read and costs no extra request — provided both pass the same `locale`,
   * which is part of the query key.
   *
   * `enabled` is here because the tab bar can mount before the product id resolves.
   */
  const useWhatPeopleSay = (params: WhatPeopleSayQueryParams, options?: { enabled?: boolean }) =>
    useQuery({ ...WHAT_PEOPLE_SAY_QUERIES.getWhatPeopleSay(params), ...options });

  return { useSuspenseWhatPeopleSay, useWhatPeopleSay };
};
